export default "__VITE_ASSET__DifVNoqH__"